export default {
  name: 'Cuota personalizada',
  path: '/offer/:uid',
  component: () => import('./cuota-personalizada-page.vue'),
  meta: {
    public: true
  }
};
